export const DEFAULT_DAILY_AVAILABILITIES = [
  true,
  ['07:00:00', '11:00:00'],
  ['11:00:00', '15:00:00'],
  ['15:00:00', '19:00:00'],
  ['19:00:00', '22:00:00'],
];
